import React from "react";

const TONE_CLASS_NAMES = {
  light: "bg-white/[0.16]",
  strong: "bg-white/[0.24]",
  dark: "bg-black/[0.12]",
  blue: "bg-[#3E6FFB]/25",
};

export function LoadingSkeleton({
  as: Component = "span",
  className = "",
  tone = "light",
  ...rest
}) {
  return (
    <Component
      aria-hidden="true"
      className={`vg-chat-loading-shimmer block rounded-full ${
        TONE_CLASS_NAMES[tone] || TONE_CLASS_NAMES.light
      } ${className}`}
      {...rest}
    />
  );
}

export function LoadingAvatarSkeleton({
  className = "h-12 w-12",
  tone = "light",
  ...rest
}) {
  return (
    <LoadingSkeleton
      className={`shrink-0 rounded-full ${className}`}
      tone={tone}
      {...rest}
    />
  );
}

export function LoadingMapSkeleton({ className = "", dark = false }) {
  return (
    <div
      aria-hidden="true"
      className={`absolute inset-0 overflow-hidden ${
        dark ? "bg-[#16223a]" : "bg-[#d6dce7]"
      } ${className}`}
    >
      <LoadingSkeleton
        tone={dark ? "light" : "dark"}
        className="absolute -left-[12%] top-[23%] h-3 w-[78%] rotate-[16deg] rounded-md opacity-70"
      />
      <LoadingSkeleton
        tone={dark ? "light" : "dark"}
        className="absolute right-[-18%] top-[52%] h-4 w-[92%] -rotate-[22deg] rounded-md opacity-60"
      />
      <LoadingSkeleton
        tone={dark ? "light" : "dark"}
        className="absolute left-[16%] bottom-[14%] h-3 w-[70%] rotate-[7deg] rounded-md opacity-50"
      />
      <LoadingSkeleton
        tone={dark ? "strong" : "blue"}
        className="absolute left-1/2 top-1/2 h-12 w-12 -translate-x-1/2 -translate-y-1/2 rounded-full shadow-[0_10px_24px_rgba(0,0,0,0.12)]"
      />
    </div>
  );
}

export default LoadingSkeleton;
